import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getFavouriteListings } from './favorite.api';
import { FavouriteSearchParams } from './favorite.type';

import { ApiFnReturnType } from '@/slw/shared/query-client';

export const FAVOURITE_LISTINGS_QUERY_KEY = 'favourite-listings';

export const useFavouriteListings = (id: string, params: FavouriteSearchParams) =>
  useQuery<ApiFnReturnType<typeof getFavouriteListings>>({
    queryKey: [FAVOURITE_LISTINGS_QUERY_KEY, id, params],
    queryFn: () => getFavouriteListings(params),
    placeholderData: keepPreviousData,
    enabled: !!id,
  });
